import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d276e356"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "button" }
const _hoisted_2 = { class: "file-icon" }
const _hoisted_3 = { class: "text" }
const _hoisted_4 = { class: "text-m-regular" }
const _hoisted_5 = { class: "text-s-light" }
const _hoisted_6 = { class: "download-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_use_svg = _resolveComponent("use-svg")!

  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_use_svg, { svg: _ctx.getSvg }, null, 8, ["svg"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.downloadData.title), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.downloadData.date), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_use_svg, {
        svg: "download",
        height: 15,
        width: 15
      })
    ])
  ]))
}